export interface SeasonalWindow {
  startMonth: number; // 1-12
  endMonth: number; // 1-12
}

/**
 * Whether `date` falls within a covered service's seasonal window (mirror of the
 * backend rule). Inclusive ends; startMonth > endMonth wraps the year (Nov–Feb).
 * No window → always within.
 */
export function isWithinSeasonalWindow(
  window: SeasonalWindow | null | undefined,
  date: Date = new Date(),
): boolean {
  if (!window) return true;
  const start = Number(window.startMonth);
  const end = Number(window.endMonth);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return true;
  const month = date.getMonth() + 1;
  if (start <= end) return month >= start && month <= end;
  return month >= start || month <= end;
}

const MONTH_ABBR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/** "Mar–Apr" label for a window, or null when there is none. */
export function formatSeasonalWindow(window: SeasonalWindow | null | undefined): string | null {
  if (!window) return null;
  const start = MONTH_ABBR[(Number(window.startMonth) - 1) % 12];
  const end = MONTH_ABBR[(Number(window.endMonth) - 1) % 12];
  if (!start || !end) return null;
  return `${start}–${end}`;
}
